/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, DestroyRef, Input, OnInit, inject} from '@angular/core';
import template from './report-template-list-page.component.html';

import {SignalAdminListColumn, SignalAdminResourceListStateFactory} from '../common/controller/signal-admin-resource-list-state';
import {ReportTemplateApiService, ReportTemplateModel} from './report-template-api.service';
import {ADVERTISING_SHARED} from '../advertising/advertising-shared';

@Component({
  standalone: true,
  imports: [...ADVERTISING_SHARED],
  selector: 'adn-report-template-list-page',
  template
})
export class ReportTemplateListPageComponent implements OnInit {
  readonly itemStateName = 'app.rep.report-templates.report-template';

  columns: SignalAdminListColumn[] = [
    {param: 'name'},
    {label: 'reportType', param: 'reportType'},
    {label: 'team', param: '', sortable: false}
  ];

  readonly list = inject(SignalAdminResourceListStateFactory).create<ReportTemplateModel>(
    inject(ReportTemplateApiService),
    {listId: 'fullReportTemplateList'},
    inject(DestroyRef)
  );

  @Input()
  set readOnly(value: boolean) {
    this.list.readOnly.set(value);
  }

  ngOnInit(): void {
    this.list.load();
  }
}
